<div class="cvv">
  <sl-input
      ngDefaultControl
      class="cvv__input"
      [name]="key"
      [label]="props.label | htmlDecode"
      [type]="props['type']"
      [readonly]="props.readonly"
      [disabled]="props.disabled || false"
      [required]="props.required || false"
      [placeholder]="props.placeholder"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [passwordToggle]="props['toggle']"
      [value]="props['defaultValue']"
      [helpText]="props['helpText']">
  </sl-input>
  <a class="cvv__link" target="_blank" href="https://www.cvvnumber.com/cvv.html">What is my CVV code?</a>
</div>
